const API_BASE = import.meta.env.VITE_API_BASE_URL || "/v2/api";

/**
 * Fetch all pages from a paginated DRF list endpoint.
 * Handles both paginated { count, next, results } and plain array responses.
 */
export async function fetchAllQuizzes() {
  const results = [];
  let next = `${API_BASE}/quizzes/`;

  while (next) {
    const res = await fetch(next);
    if (!res.ok) throw new Error("Failed to load quizzes");
    const data = await res.json();

    if (Array.isArray(data)) {
      return data;
    }

    results.push(...(data.results || []));
    next = data.next || null;
  }

  return results;
}
